__turbopack_context__.v({
  "block": "_RAh5W_block",
  "buying": "_RAh5W_buying",
  "buyingGrid": "_RAh5W_buyingGrid",
  "buyingGroup": "_RAh5W_buyingGroup",
  "buyingGroups": "_RAh5W_buyingGroups",
  "directory": "_RAh5W_directory",
  "featuredCaption": "_RAh5W_featuredCaption",
  "featuredCard": "_RAh5W_featuredCard",
  "featuredGrid": "_RAh5W_featuredGrid",
  "featuredItem": "_RAh5W_featuredItem",
  "featuredLogo": "_RAh5W_featuredLogo",
  "featuredLogoFrame": "_RAh5W_featuredLogoFrame",
  "featuredName": "_RAh5W_featuredName",
  "logoFallback": "_RAh5W_logoFallback",
  "logoImage": "_RAh5W_logoImage",
  "logoSlot": "_RAh5W_logoSlot",
  "note": "_RAh5W_note",
});
